import React from 'react';
import {Chip, Tooltip} from '@mui/material';
import {useTranslation} from 'react-i18next';

export default function StatusBadge({status}) {
    const {t} = useTranslation();
    if (!status) return null;
    let color = 'default';
    if (['BOOKED'].includes(status)) color = 'success';
    else if (['BOOKED_AWAIT_ADVANCE'].includes(status)) color = 'warning';
    else if (['CANCELLED'].includes(status)) color = 'error';

    const label = t(`statuses.${status}`, status.replaceAll('_', ' '));

    return <Tooltip title={label} arrow>
        <Chip size="small" label={label} color={color} variant={color === 'default' ? 'outlined' : 'filled'}/>
    </Tooltip>;
}
